export interface ContentEditState {
  isPolling: boolean;
}

class ContentEditStateDefinition {
  static getInitialState(): ContentEditState {
    // The server seeds this from ContentEditService::getInProgressJob() (see
    // NavBarViewModel::getInitialReduxState). false is only the pre-hydration default.
    return {
      isPolling: false,
    };
  }
}

export default ContentEditStateDefinition;
